<template>
  <TutorialDoll :currentScreen="currentScreen" />
</template>

<script>
import incein from '@/mixins/incein';
import TutorialDoll from './TutorialDoll.vue';
import foot from '../../assets/stamp/left-feet.png';
import feetCombination from '../../assets/stamp/feetCombination.png';
import feetCombinationIncein from '../../assets/stamp/incein-feetCombination.svg';

export default {
  name: 'FeetPos',
  components: {
    TutorialDoll,
  },
  mixins: [incein],
  computed: {
    currentScreen() {
      return {
        src: this.isIncein ? feetCombinationIncein : feetCombination,
        zoom: 'h-48 mt-20',
        frontImg: [
          {
            id: 1,
            src: foot,
            cls: 'lFoot h-48 absolute',
          },
          {
            id: 2,
            src: foot,
            cls: 'rFoot h-48 absolute',
          },
        ],
      };
    },
  },
};
</script>
